import { useState, useEffect } from 'react';
import Home from './kuldeepanand-home';
import CertApp from './cert-ui';

function usePathRoute() {
  const getRoute = () => window.location.pathname || '/';
  const [route, setRoute] = useState(getRoute);

  useEffect(() => {
    const handler = () => setRoute(getRoute());
    window.addEventListener('popstate', handler);
    return () => window.removeEventListener('popstate', handler);
  }, []);

  return route;
}

export default function App() {
  const route = usePathRoute();

  if (route.startsWith('/certificate')) return <CertApp />;
  return <Home />;
}
